<template>
  <div>
    <a-modal title="查看编辑" style="top: 20px" :width="1200" v-model="visible2" :confirmLoading="confirmLoading"
      @cancel="handleClose" :maskClosable="false" :footer="false">
      <a-button v-if="areaEnable" type="primary" @click="coverage">服务区域</a-button>
      <a-button type="primary" style="margin-left: 1%" @click="handlePass">修改密码</a-button>
      <a-button v-if="resetPwdEnable" type="primary" @click="resetPwd(passReset)" style="margin-left: 1%">重置密码
      </a-button>
      <a-button type="primary" @click="handleMembers" style="margin-left: 1%">查看会员</a-button>
      <a-tabs :activeKey="activeKey" @change="callback1">
        <a-tab-pane v-if="infoBase" tab="师傅信息" key="1">
          <div class="table-page-search-wrapper">
            <a-form :form="form" layout="inline" @submit="handleSubmit"
              :class="[enterpriseShow == 0 ? 'disEvents' : 'disEvents2']">
              <div style="margin-bottom: 30px">
                <span style="color: deepskyblue; font-size: 20px">基本信息 :</span>
                <span :class="nameAuth == 1 ? 'changeColor' : ''"
                  style="padding: 3px 15px; border: 1px solid #aaa; border-radius: 50% / 50%; margin-left: 10px">实名认证</span>
                <span :class="bond > 0 ? 'changeColor' : ''"
                  style="padding: 3px 22px; border: 1px solid #aaa; border-radius: 50% / 50%; margin-left: 10px">保证金</span>
              </div>
              <!--全-->
              <a-row v-if="baseCommon && baseInner" :gutter="16">
                <a-col :span="6">
                  <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" :disabled="isTrueText"
                    style="margin-left: 56px">
                    <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol" :disabled="isTrueText"
                    style="margin-left: 70px">
                    <a-select v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }] }]">
                      <a-select-option v-for="type in restaurantTypes7" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 2px">
                    <a-input v-decorator="['loginName', { rules: [{ validator: this.userText, required: true }] }]"
                      autocomplete="off" disabled="true" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['phonenumber', { rules: [{ validator: this.isPhone, required: true }] }]"
                      autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="备用联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 11px">
                    <a-input v-decorator="['contactReserve']" autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="单日最大接单量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="[
                      'maxReceiveOrder',
                      { rules: [{ required: true, message: '请输入单日最大接单量' }] }
                    ]" autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :span="24">
                  <a-row :gutter="16">
                    <a-col :span="12">
                      <a-form-item label="平台使用情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select mode="multiple"
                          v-decorator="['platformType', { rules: [{ required: true, message: '请选择平台使用情况' }] }]">
                          <a-select-option v-for="type in restaurantTypes6" :key="type.code">{{
                             type.label 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="12">
                      <a-form-item label="接单方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select mode="multiple" @change="haveSelect"
                          v-decorator="['receiptType', { rules: [{ required: true, message: '请选择接单方式' }] }]">
                          <a-select-option v-for="type in restaurantTypes3" :key="type.code">{{
                             type.label 
                            }}</a-select-option>
                        </a-select>
                        <!-- <a-col :span="4" style="margin-left: 27px">
                            <a-button v-if="areaEnable" type="primary" v-show="open1" @click="Tomap"
                              >电子围栏 1</a-button
                            >
                          </a-col> -->
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="18">
                  <a-row :gutter="4">
                    <a-col :span="7">
                      <a-form-item label="注册地址" style="margin-left: 28px">
                        <a-select v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]"
                          @change="haveProvince3">
                          <a-select-option v-for="type in data1" :key="type.provinceCode">{{
                             type.provinceName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item label="">
                        <a-select v-decorator="['cityId', { rules: [{ required: true, message: '请选择市' }] }]"
                          @change="haveProvince4">
                          <a-select-option v-for="type in data2" :key="type.cityCode">{{
                             type.cityName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item label="">
                        <a-select v-decorator="['districtId', { rules: [{ required: true, message: '请选择区' }] }]"
                          @change="haveProvince5">
                          <a-select-option v-for="type in data3" :key="type.areaCode">{{
                             type.areaName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-item label="">
                        <a-input
                          v-decorator="['detailedAddress', { rules: [{ required: true, message: '请输入详情地址' }] }]" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="派单置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                    <a-select v-decorator="['isTop']" allowClear="true">
                      <a-select-option value="0"> 不是 </a-select-option>
                      <a-select-option value="1"> 是 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <!--内部-->
              <a-row v-if="baseInner && !baseCommon" :gutter="16">
                <a-col :span="12">
                  <a-form-item label="平台使用情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select mode="multiple"
                      v-decorator="['platformType', { rules: [{ required: true, message: '请选择平台使用情况' }] }]">
                      <a-select-option v-for="type in restaurantTypes6" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="派单置顶" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                    <a-select v-decorator="['isTop']" allowClear="true">
                      <a-select-option value="0"> 不是 </a-select-option>
                      <a-select-option value="1"> 是 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
              </a-row>
              <!--通用-->
              <a-row v-if="baseCommon && !baseInner" :gutter="16">
                <a-col :span="6">
                  <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol" :disabled="isTrueText"
                    style="margin-left: 56px">
                    <a-input v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol" :disabled="isTrueText"
                    style="margin-left: 70px">
                    <a-select v-decorator="['sex', { rules: [{ required: true, message: '请选择性别' }] }]">
                      <a-select-option v-for="type in restaurantTypes7" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="用户名" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 2px">
                    <a-input v-decorator="['loginName', { rules: [{ validator: this.userText, required: true }] }]"
                      autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['phonenumber', { rules: [{ validator: this.isPhone, required: true }] }]"
                      autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="备用联系方式" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 11px">
                    <a-input v-decorator="['contactReserve']" autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="单日最大接单量" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="[
                      'maxReceiveOrder',
                      { rules: [{ required: true, message: '请输入单日最大接单量' }] }
                    ]" autocomplete="off" />
                  </a-form-item>
                </a-col>

                <a-col :span="24" style="margin-left: 36px">
                  <a-row :gutter="16">
                    <a-form-item label="接单方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-col :span="18">
                        <a-select mode="multiple" @change="haveSelect"
                          v-decorator="['receiptType', { rules: [{ required: true, message: '请选择接单方式' }] }]">
                          <a-select-option v-for="type in restaurantTypes3" :key="type.code">{{
                             type.label 
                            }}</a-select-option>
                        </a-select>
                      </a-col>
                      <a-col :span="4" style="margin-left: 27px">
                        <a-button v-if="areaEnable" type="primary" v-show="open1" @click="Tomap">电子围栏</a-button>
                      </a-col>
                    </a-form-item>
                  </a-row>
                </a-col>
                <a-col :span="18">
                  <a-row :gutter="4">
                    <a-col :span="7">
                      <a-form-item label="注册地址" style="margin-left: 28px">
                        <a-select v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省' }] }]"
                          @change="haveProvince3">
                          <a-select-option v-for="type in data1" :key="type.provinceCode">{{
                             type.provinceName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item label="">
                        <a-select v-decorator="['cityId', { rules: [{ required: true, message: '请选择市' }] }]"
                          @change="haveProvince4">
                          <a-select-option v-for="type in data2" :key="type.cityCode">{{
                             type.cityName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="5">
                      <a-form-item label="">
                        <a-select v-decorator="['districtId', { rules: [{ required: true, message: '请选择区' }] }]"
                          @change="haveProvince5">
                          <a-select-option v-for="type in data3" :key="type.areaCode">{{
                             type.areaName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-item label="">
                        <a-input
                          v-decorator="['detailedAddress', { rules: [{ required: true, message: '请输入详情地址' }] }]" />
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <!--服务类别-->
              <a-row v-if="baseCommon" :gutter="16" style="margin-bottom: 60px">
                <a-col :span="18">
                  <a-form-item label="服务类别" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-checkbox-group v-decorator="[
                      'installType.installType',
                      { rules: [{ required: true, message: '请选择服务类别' }], initialValue: addd }
                    ]" style="width: 100%; margin-top: 5px" @change="handleCheck11">
                      <a-checkbox v-for="type in restaurantTypes1" :value="type.code">
                        {{  type.label  }}
                      </a-checkbox>
                    </a-checkbox-group>
                  </a-form-item>
                  <a-form-item>
                    <a-tabs ref="tabPane" @change="callback2" type="card">
                      <a-tab-pane v-for="type in installTabs" :tab="type.label" :key="type.code">
                        <a-form-item label="标签" :labelCol="labelCol" :wrapperCol="wrapperCol" class="redItem"
                          v-if="baseInner">
                          <a-checkbox-group
                            v-decorator="['masterLabel' + '$' + type.code, { initialValue: getInitalValue(type.code) }]"
                            style="width: 100%; margin-top: 5px" @change="handleCheck2"
                            :key="'masterLabel' + '$' + type.code">
                            <a-checkbox @change="tabChecked" v-for="item in data4[type.code]"
                              :value="item.installLabelId" :key="type.code + item.installLabelId">
                              {{  item.installLabelName  }}
                            </a-checkbox>
                          </a-checkbox-group>
                        </a-form-item>
                      </a-tab-pane>
                    </a-tabs>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-row>
                    <a-col :span="24" v-if="relationId == 1">
                      <a-form-item label="渠道负责人" :labelCol="labelCol" :wrapperCol="wrapperCol"
                        style="margin-left: 10px">
                        <a-input v-decorator="['masterProvinceName']" disabled></a-input>
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select v-decorator="['masterLeading', { rules: [{ required: true, message: '请选择师傅负责人' }] }]">
                          <a-select-option v-for="type in pullDown" :key="type.userId">{{
                             type.userName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="24">
                      <a-form-item label="角色" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 42px">
                        <a-select v-decorator="['roleIds', { rules: [{ required: true, message: '请选择角色' }] }]">
                          <a-select-option v-for="type in roleAll" :key="type.roleId">{{
                             type.roleName 
                            }}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <!--雷达图-->
              <a-row v-if="baseCommon" :gutter="16">
                <a-col :span="10">
                  <div style="min-height: 300px">
                    <!--雷达图-->
                    <div ref="chart" style="margin-top: 30px; width: 300px; height: 300px"></div>
                    <div id="alert">
                      <a-card :title="ScoreArr.installType" :bordered="false" style="width: 190px">
                        <p>虚拟得分1:{{  ScoreArr.firstFicScore  }}</p>
                        <p>虚拟得分2:{{  ScoreArr.secondFicScore  }}</p>
                        <p>虚拟得分透明度1:{{  ScoreArr.firstFicTransparency  }}</p>
                        <p>虚拟得分透明度2:{{  ScoreArr.secondFicTransparency  }}</p>
                      </a-card>
                    </div>
                  </div>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="得分" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="abilityScore" disabled></a-input>
                  </a-form-item>
                  <a-form-item label="接单情况" :labelCol="labelCol" :wrapperCol="wrapperCol"></a-form-item>
                  <a-table :columns="columns6" :dataSource="orderReceive" bordered :pagination="false">
                    <span slot="receiveOrderSingle" slot-scope="text, record">
                      <a-popover>
                        <template slot="content">
                          <span>近三个月总接单量: </span>
                          <span> {{  orderReceive[0].receiveOrderSingleMonth  }}</span>
                        </template>
                        <span>{{  orderReceive[0].receiveOrderSingle  }}</span>
                      </a-popover>
                    </span>
                  </a-table>
                </a-col>
              </a-row>

              <a-row :gutter="16">
                <div style="margin: 20px 10px">
                  <span style="color: deepskyblue; font-size: 20px">师傅钱包 :</span>
                </div>
                <a-col :span="12" :offset="1">
                  <a-table :columns="columns2" :data-source="setData2" bordered :pagination="false"> </a-table>
                </a-col>
              </a-row>

              <a-row v-if="archivesCommon && innerArchivesEnable" :gutter="16">
                <div style="margin: 20px 10px">
                  <span style="color: deepskyblue; font-size: 20px">师傅档案 :</span>
                </div>
                <a-col :span="6">
                  <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['workerType', { rules: [{ required: true, message: '请输入师傅类型' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="师傅等级" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['techLevel']" :disabled="!editInnerArchivesEnable" allowClear="true">
                      <a-select-option v-for="type in restaurantTypes2" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['cashStatus', { rules: [{ required: true, message: '请选择提现方式' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes5" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['cashCycle', { rules: [{ required: true, message: '请选择提现周期' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes4" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 40px">
                    <a-select v-decorator="['privateMaster']" :disabled="!editInnerArchivesEnable" allowClear="true">
                      <a-select-option value="0"> 不是 </a-select-option>
                      <a-select-option value="1"> 是 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="户名" style="margin-left: 40px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['cardHouseHolder']" :disabled="!editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left: 26px" label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select showSearch optionFilterProp="children" v-decorator="['cardOrg']"
                      :filterOption="filterOption" :disabled="!editCommon" allowClear="true">
                      <a-select-option v-for="item of bankName" :title="item.name" :key="item.id">{{
                         item.name 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="银行卡账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['cardNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
                      :disabled="!editCommon" autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="保证金" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                    <a-input v-decorator="['bond']" autocomplete="off" :disabled="editInnerArchivesEnable" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="缴纳时间" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-date-picker :disabled="!editInnerArchivesEnable" style="width: 100%" v-model="bondTime" show-time
                      :allowClear="false" @change="onChange1" format="YYYY-MM-DD HH:mm:ss" @ok="onOk1" />
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item style="margin-left: 12px" label="师傅备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['masterRemark']" autocomplete="off" :disabled="!editInnerArchivesEnable" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="身份证号" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['idCard', { rules: [{ required: true }] }]" autocomplete="off"
                      :disabled="isTrueText || !editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="证件有效期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker v-decorator="['time']" format="YYYY-MM-DD" @change="onChange2" @ok="onOk"
                      :allowClear="false" :disabled="isTrueTime || !editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="7" :offset="5">
                  <a-form-item label="总接单情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-decorator="['privateMaster']"  style="width: 230px;"/>-->
                    <a-table bordered :dataSource="setData" :columns="columns1" :pagination="false" size="small">
                    </a-table>
                  </a-form-item>
                </a-col>
              </a-row>
              <!--内部-->
              <a-row v-if="!archivesCommon && innerArchivesEnable" :gutter="16">
                <div style="margin: 20px 10px">
                  <span style="color: deepskyblue; font-size: 20px">师傅档案 :</span>
                </div>
                <a-col :span="6">
                  <a-form-item label="师傅等级" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['techLevel']" :disabled="!editInnerArchivesEnable" allowClear="true">
                      <a-select-option v-for="type in restaurantTypes2" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="私密" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 40px">
                    <a-select v-decorator="['privateMaster']" :disabled="!editInnerArchivesEnable" allowClear="true">
                      <a-select-option value="0"> 不是 </a-select-option>
                      <a-select-option value="1"> 是 </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left: 12px" label="师傅备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['masterRemark']" autocomplete="off" :disabled="!editInnerArchivesEnable" />
                  </a-form-item>
                </a-col>
              </a-row>
              <!--通用-->
              <a-row v-if="archivesCommon && !innerArchivesEnable" :gutter="16">
                <div style="margin: 20px 10px">
                  <span style="color: deepskyblue; font-size: 20px">师傅档案 :</span>
                </div>
                <a-col :span="6">
                  <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['workerType', { rules: [{ required: true, message: '请输入师傅类型' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现方式" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['cashStatus', { rules: [{ required: true, message: '请选择提现方式' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes5" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="提现周期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-decorator="['cashCycle', { rules: [{ required: true, message: '请选择提现周期' }] }]"
                      :disabled="!editInnerArchivesEnable">
                      <a-select-option v-for="type in restaurantTypes4" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="户名" style="margin-left: 40px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['cardHouseHolder']" :disabled="!editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left: 26px" label="开户行" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-decorator="['cardOrg']" autocomplete="off" :disabled="!editCommon"/>-->
                    <a-select showSearch optionFilterProp="children" v-decorator="['cardOrg']"
                      :filterOption="filterOption" :disabled="!editCommon" allowClear="true">
                      <a-select-option v-for="item of bankName" :title="item.name" :key="item.id">{{
                         item.name 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="银行卡账号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['cardNumber', { rules: [{ validator: this.bankNum, required: false }] }]"
                      :disabled="!editCommon" autocomplete="off" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="保证金" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 26px">
                    <a-input v-decorator="['bond']" autocomplete="off" :disabled="!editInnerArchivesEnable" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="缴纳时间" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-date-picker-->
                    <!--:value="moment(bondTime,dateFormat)"-->
                    <!--format="YYYY-MM-DD HH:mm:ss"-->
                    <!--style="width: 100%"-->
                    <!--showTime-->
                    <!--@change="onChange1"-->
                    <!--@ok="onOk1"-->
                    <!--/>-->

                    <a-date-picker :disabled="!editInnerArchivesEnable" style="width: 100%" v-model="bondTime" show-time
                      :allowClear="false" @change="onChange1" format="YYYY-MM-DD HH:mm:ss" @ok="onOk1" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="身份证号" style="margin-left: 13px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['idCard', { rules: [{ validator: this.idCards, required: false }] }]"
                      autocomplete="off" :disabled="isTrueText || !editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="证件有效期" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker v-decorator="['time']" format="YYYY-MM-DD" @change="onChange2" @ok="onOk"
                      :allowClear="false" :disabled="isTrueTime || !editCommon" />
                  </a-form-item>
                </a-col>
                <a-col :span="7" :offset="5">
                  <a-form-item label="总接单情况" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <!--<a-input v-decorator="['privateMaster']"  style="width: 230px;"/>-->
                    <a-table bordered :dataSource="setData" :columns="columns1" :pagination="false" size="small">
                    </a-table>
                  </a-form-item>
                </a-col>
              </a-row>

              <!--上传身份证图片-->
              <a-row v-if="archivesCommon" :gutter="16">
                <a-col :span="6">
                  <a-form-item label="身份证正面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                    <div class="clearfix">
                      <a-upload :action="uploadUrlb" listType="picture-card" :fileList="fileList1" :headers="headers"
                        :beforeUpload="beforeUpload1" @preview="handPreview1" @change="handChange1"
                        :disabled="!editCommon">
                        <div v-if="fileList1.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">身份证正面</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible1" :footer="null" @cancel="handCancel1">
                        <img alt="example" style="width: 100%" :src="coverUrl1" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="身份证背面" :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 15 } }">
                    <div class="clearfix">
                      <a-upload :action="uploadUrlb" listType="picture-card" :fileList="fileList2" :headers="headers"
                        :beforeUpload="beforeUpload1" @preview="handPreview2" @change="handChange2"
                        :disabled="!editCommon">
                        <div v-if="fileList2.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">身份证反面</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible2" :footer="null" @cancel="handCancel2">
                        <img alt="example" style="width: 100%" :src="coverUrl2" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item style="margin-left: 12px" label="免冠照片"
                    :labelCol="{ labelCol: { span: 9 }, wrapperCol: { span: 24 } }">
                    <div class="clearfix">
                      <a-upload :action="uploadUrlb" listType="picture-card" :fileList="fileList3" :headers="headers"
                        :beforeUpload="beforeUpload1" @preview="handPreview3" @change="handChange3"
                        :disabled="!editCommon">
                        <div v-if="fileList3.length < 1">
                          <a-icon type="plus" />
                          <div class="ant-upload-text">免冠照</div>
                        </div>
                      </a-upload>
                      <a-modal :visible="previewVisible3" :footer="null" @cancel="handCancel3">
                        <img alt="example" style="width: 100%" :src="coverUrl3" />
                      </a-modal>
                    </div>
                  </a-form-item>
                </a-col>
              </a-row>

              <!--合同信息-->
              <a-row :gutter="16" style="margin-top: 70px">
                <a-col :span="24" style="margin-bottom: 20px">
                  <span>合同上传:</span>
                  <a-upload name="file" :multiple="true" :action="uploadUrl" :headers="headers"
                    :beforeUpload="beforeUpload" @change="uploadChange" :fileList="fileList4">
                    <a-button v-if="editsViewEnable" class="twobtn" style="margin-left: 10px" type="primary">上传
                    </a-button>
                  </a-upload>
                  <a-table :dataSource="contractData" :columns="columns3" :pagination="false" size="small"
                    style="margin-top: 10px">
                    <span slot="action" slot-scope="text, record">
                      <span v-if="detailsViewEnable">
                        <a @click="handleSee(record)">查看</a>
                        <a-divider type="vertical" />
                        <a @click="download(record)">下载</a>
                        <a-divider v-if="deleteViewEnable || editsViewEnable" type="vertical" />
                      </span>
                      <span v-if="editsViewEnable">
                        <a v-if="record.forbiddenStatus == 1"
                          @click="showState(record.masterContractId, record.forbiddenStatus)">启用</a>
                        <a v-else @click="showState(record.masterContractId, record.forbiddenStatus)">禁用</a>
                        <a-divider v-if="deleteViewEnable" type="vertical" />
                      </span>
                      <a v-if="deleteViewEnable" @click="delByIds(record.masterContractId)">删除</a>
                    </span>
                    <template slot="contractNo" slot-scope="text, record">
                      <editable-cell :text="text" @change="onCellChange(record, 'contractNo', $event)" />
                    </template>
                    <template slot="contractName" slot-scope="text, record">
                      <editable-cell :text="text" @change="onCellChange(record, 'contractName', $event)" />
                    </template>
                    <template slot="time1" slot-scope="text, record">
                      <editable-cell2 :start="record.contractStartTime" :end="record.contractEndTime"
                        @change="onCellChange2(record, 'time1', $event)" />
                    </template>
                    <a slot="action2" slot-scope="text, record">
                      <a-checkbox @change="checkChange(record)" :default-checked="record.isMainContract != '0'">
                        主合同
                      </a-checkbox>
                    </a>
                  </a-table>
                </a-col>
              </a-row>
              <a-row :gutter="16" style="margin-bottom: 60px" v-if="innerArchivesEnable">
                <a-col :span="24">
                  <a-form-item label="备注" style="width: 100%; margin-bottom: 20px">
                    <a-textarea v-decorator="['remark']" :disabled="!editInnerArchivesEnable" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-row :span="24" style="margin-top: 40px" v-if="enterpriseShow != 0">
                <a-affix style="position: fixed; bottom: 52px; left: 40%; z-index: 10">
                  <div style="width: 160px">
                    <a-button style="float: left" type="primary" html-type="submit">提交</a-button>
                    <a-button style="float: right" @click="getClose">取消</a-button>
                  </div>
                </a-affix>
                <!--<a-affix style="position: fixed; bottom:8px; left: 40%; z-index: 10;">-->
                <!--<div style="width:700px;">-->

                <!--<a-button style="margin-right: 50px;float: left" type="primary" @click="orderSubmit()">提交</a-button>-->
                <!--<a-button v-if="hodleOrderEditStuda==0" style="margin-right: 50px;float: left" type="primary" @click="hodleOrder()">挂起</a-button>-->
                <!--<a-button v-else style="margin-right: 50px;float: left"   @click="hodleOrderEdit()">取消挂起</a-button>-->
                <!--<a-button type="primary" style="margin-right: 50px;float: left" @click="orderRefresh">刷新</a-button>-->
                <!--<a-button style="margin-right: 50px;float: left" @click="ordercancel">取消</a-button>-->

                <!--</div>-->
                <!--</a-affix>-->
              </a-row>
            </a-form>
          </div>
        </a-tab-pane>
        <a-tab-pane v-if="viewPrice" tab="金额信息" key="2" forceRender>
          <a-tabs @change="callback3" type="card">
            <a-tab-pane v-for="items in money" :tab="items.installName" :key="items.installType">
              <a-form :form="form3" layout="horizontal" style="margin-left: 30px"
                :class="[enterpriseShow == 0 ? 'disEvents' : 'disEvents2']">
                <a-row :gutter="16" v-for="item in items.masterPriceDto" :key="item.masterPriceId">
                  <a-col :span="8" :offset="3">
                    <a-form-item :label="item.priceName" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input v-model="item.price" :disabled="!editPriceEnable" style="width: 100%"
                        v-if="showPriceEnable" />
                      <span v-else>
                        <a-icon type="exclamation-circle" style="color: #ffc53d" />
                        <span style="color: #aaaaaa"> 您没有查看权限</span>
                      </span>
                      <!--<a-input v-decorator="['price$' + item.masterPriceId]" />-->
                    </a-form-item>
                  </a-col>
                  <a-col :span="8">
                    <a-form-item label="备注" :label-col="{ span: 10 }" :wrapper-col="{ span: 14 }">
                      <a-input v-model="item.priceRemark" style="width: 300px" v-if="showRemarkEnable" />
                      <span v-else>
                        <a-icon type="exclamation-circle" style="color: #ffc53d" />
                        <span style="color: #aaaaaa"> 您没有查看权限</span>
                      </span>
                    </a-form-item>
                  </a-col>
                </a-row>
              </a-form>
            </a-tab-pane>
            <a-tab-pane tab="配件" key="3">
              <div v-for="type in accessories">
                <div>{{  type.installType  }}</div>
                <a-table size="default" ref="table" rowKey="id" :columns="columns5"
                  :dataSource="type.masterAccessoryPriceDto" bordered>
                </a-table>
              </div>
            </a-tab-pane>
          </a-tabs>
          <div style="margin-left: 35%; margin-top: 20px" v-if="enterpriseShow != 0">
            <a-button style="margin-right: 100px; width: 150px" type="primary" @click="handleSubmit1">提交</a-button>
            <a-button style="width: 150px" @click="getClose">取消</a-button>
          </div>
        </a-tab-pane>
        <!--<a-tab-pane tab="考试培训" key="3">略</a-tab-pane>-->
        <a-tab-pane tab="师傅履历" key="4">
          <div class="table-page-search-wrapper">
            <a-form :form="form7" layout="inline" @submit="handleSubmit7">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="师傅类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-select v-model="queryParam7.masterType" allowClear="true">
                      <a-select-option v-for="type in restaurantTypes" :key="type.code">{{
                         type.label 
                        }}</a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="操作模块" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam7.typeModel" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="操作类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam7.operationType" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="操作人员" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-model="queryParam7.masterLeading" />
                  </a-form-item>
                </a-col>

                <a-col :span="6">
                  <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-range-picker style="width: 100%" v-model="queryParam7.time" format="YYYY-MM-DD HH:mm:ss"
                      :show-time="{
                        hideDisabledOptions: true,
                        defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')]
                      }" @change="onChange3" @ok="onOk" />
                  </a-form-item>
                </a-col>
                <a-col :span="4" :offset="12">
                  <a-button type="primary" style="margin-right: 5px" @click="handleSelect">查询</a-button>
                  <a-button @click="handleClear">清空</a-button>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <s-table size="default" ref="table7" :columns="columns7" :data="loadData7" :scroll="{ x: 1500 }" bordered>
            <span slot="action7" slot-scope="text, record">
              <div style="max-height: 150px; overflow-x: auto">
                <span v-if="record.formatType == 0">{{  text  }}</span>
                <div v-else-if="record.formatType == 1" v-for="(item, index) in JSON.parse(text)">
                  <div v-if="item.label != '证件有效期' && item.label != '缴纳时间'">
                    <p v-if="item.newValue && item.oldValue">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】修改前:<span>{{  item.oldValue  }}</span> 修改后:<span style="color: red">{{
                           item.newValue 
                          }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.newValue">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】新增:<span style="color: red">{{  item.newValue  }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.oldValue">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】删除:<span>{{  item.oldValue  }}</span>
                      </span>
                    </p>
                    <!--<p v-if="JSON.parse(text).length==1">-->
                    <!--【{{item.label}}】<strong> 新增: </strong><span style="color:red">{{item.newValue}}</span>-->
                    <!--</p>-->
                    <!--<p v-else-if="item.newValue && item.oldValue">-->
                    <!--{{index+1}}.【{{item.label}}】<strong> 修改前: </strong><span>{{item.oldValue}}</span> <strong> 修改后: </strong><span style="color:red">{{item.newValue}}</span>-->
                    <!--</p>-->
                    <!--<p v-else-if="item.newValue">-->
                    <!--{{index+1}}.【{{item.label}}】<strong> 新增: </strong><span style="color:red">{{item.newValue}}</span>-->
                    <!--</p>-->
                    <!--<p v-else-if="item.oldValue">-->
                    <!--{{index+1}}.【{{item.label}}】<strong> 删除: </strong><span>{{item.oldValue}}</span>-->
                    <!--</p>-->
                  </div>
                  <div v-if="item.label == '证件有效期'">
                    <p v-if="item.newValue != 'null-null' && item.oldValue == 'null-null'">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 新增: </strong><span style="color: red">{{  item.newValue  }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.oldValue != 'null-null' && item.newValue == 'null-null'">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 删除: </strong><span>{{  item.oldValue  }}</span>
                      </span>
                    </p>
                    <p v-else>
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 修改前: </strong><span>{{  item.oldValue  }}</span>
                        <strong> 修改后: </strong><span style="color: red">{{  item.newValue  }}</span>
                      </span>
                    </p>
                  </div>
                  <div v-if="item.label == '缴纳时间'">
                    <p v-if="item.newValue != 'null' && item.oldValue == 'null'">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 新增: </strong><span style="color: red">{{  item.newValue  }}</span>
                      </span>
                    </p>
                    <p v-else-if="item.oldValue != 'null' && item.newValue == 'null'">
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 删除: </strong><span>{{  item.oldValue  }}</span>
                      </span>
                    </p>
                    <p v-else>
                      <span v-if="JSON.parse(text).length > 1">{{  index + 1  }}.</span>
                      <span>
                        【{{  item.label  }}】<strong> 修改前: </strong><span>{{  item.oldValue  }}</span>
                        <strong> 修改后: </strong><span style="color: red">{{  item.newValue  }}</span>
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </span>
          </s-table>
        </a-tab-pane>
      </a-tabs>
    </a-modal>
    <!--服务区域-->
    <a-modal title="服务区域" style="top: 20px" :width="1400" v-model="visible3" :confirmLoading="confirmLoading"
      @cancel="handleClose1" :maskClosable="false" :footer="false">
      <a-form>
        <a-form-item style="display: flex; justify-content: flex-end; margin-right: 10%">
          <a-button :disabled="!editAreaEnable" style="width: 110px; margin-left: 8px" type="primary" @click="addItem1">
            新增</a-button>
          <a-button :disabled="!editAreaEnable" style="width: 110px; margin-left: 8px" type="primary"
            @click="addItem2(record)">通过</a-button>
          <a-button :disabled="!editAreaEnable" style="width: 110px; margin-left: 8px" type="primary"
            @click="addItem3(record)">未通过</a-button>
          <a-button :disabled="!editAreaEnable" style="width: 110px; margin-left: 8px" type="primary"
            @click="delectCoverage()">删除</a-button>
        </a-form-item>
      </a-form>
      <a-table :loading="loading" :columns="columns4" :row-selection="rowSelection" :dataSource="coverageData"
        rowKey="userAreaId" :pagination="false" bordered>
        <a slot="aduitStatus" slot-scope="text, record">
          <a-text v-if="record.aduitStatus == 0">待审核 </a-text>
          <a-text v-else="record.aduitStatus == 1">审核通过</a-text>
          <!--        <span slot="aduitStatus" slot-scope="text,record">-->
          <!--          {{replece[text]}}-->
        </a>
        <!--        </span>-->
        <span slot="action" slot-scope="text, record">
          <span v-if="record.auditFlag == 1 && record.aduitStatus == 0">
            <a @click="getApproved(record)" :disabled="!editAreaEnable">审核通过</a>
            <a-divider type="vertical" />
            <a @click="notApproved(record)" :disabled="!editAreaEnable">审核不通过</a>
            <a-divider type="vertical" />
          </span>
          <!--          <a :disabled="!editAreaEnable" @click="delectCoverage(record.userAreaId)">删除</a>-->
        </span>
      </a-table>
      <a-pagination showQuickJumper="true" showSizeChanger :pageSizeOptions="pageSizeOptions" :pageSize.sync="pageSize"
        @showSizeChange="onShowSizeChange" :total="total" v-model="current" @change="getdataList1"
        :showTotal="total => `总共 ${total} 条`" style="text-align: end; margin-top: 20px" />
    </a-modal>
    <!--添加-->
    <a-modal title="添加" style="top: 20px" :width="800" v-model="visible4" :confirmLoading="confirmLoading"
      @cancel="handleClose2" :maskClosable="false" @ok="handleSubmit02">
      <a-form :form="form2" @submit="handleSubmit02">
        <a-form-item label="省份名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select v-decorator="['provinceId', { rules: [{ required: true, message: '请选择省份名称' }] }]"
            @change="haveProvince02">
            <a-select-option v-for="type in data1" :key="type.provinceCode">{{  type.provinceName  }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="城市名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-select v-decorator="['cityId', { rules: [{ required: true, message: '请选择城市' }] }]"
            @change="haveProvince03">
            <a-select-option v-for="type in cdata" :key="type.cityCode">{{  type.cityName  }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="区域名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-checkbox :checked="checkAll" @change="onChange4($event)"> 全选 </a-checkbox>
          <br />
          <a-checkbox-group v-decorator="['areaArray', { rules: [{ required: true, message: '区域名称' }] }]"
            v-for="type in sdata" @change="onChange">
            <a-checkbox :value="type.areaId">
              {{  type.areaName  }}
            </a-checkbox>
          </a-checkbox-group>
          <a-alert v-if="warnShow" message="已选择全部区域，无法添加" type="warning" show-icon />
          <!--          <a-select-->
          <!--            mode="multiple"-->
          <!--            v-decorator="['areaId', { rules:[{required: true, message: '区域名称'}]}]"-->
          <!--            -->
          <!--            @change="handChange"-->
          <!--          >-->
          <!--            <a-select-option  v-for="type in sdata" :key="type.areaId">{{type.areaName}}</a-select-option>-->
          <!--          </a-select>-->
        </a-form-item>
      </a-form>
    </a-modal>
    <!--修改密码-->
    <a-modal title="修改密码" style="top: 20px" :width="700" v-model="visible5" :confirmLoading="confirmLoading"
      :maskClosable="false" :closable="false" :footer="null">
      <a-form :form="form3" @submit="handleSubmit2">
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="原密码" has-feedback>
          <input type="password" style="display: none" />
          <a-input v-decorator="['oldPwd', { rules: [{ required: true, message: '请输入原密码!' }] }]" type="text"
            autocomplete="off" onfocus="this.type='password'" />
          <!--<a-input  v-decorator="['oldPwd', { rules:[{required: true, message: '请输入密码'}]}]" type="text" autocomplete="new-password" onfocus="this.type='password'" @change="psw"/>-->
          <!--<a-input  v-model="oldPwd" type="text"   @change="psw"/>-->
        </a-form-item>
        <!--        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码1" has-feedback>
          <a-input :min="5" :max="20"  v-decorator="['newPwd',{ rules:[{validator:passText,required: true}]}]"
                   type="text" autocomplete="off" onfocus="this.type='password'"
          />
        </a-form-item> -->
        <a-form-item maxLength="20" :labelCol="labelCol" :wrapperCol="wrapperCol" label="新密码" has-feedback>
          <a-input :min="5" :max="20" v-decorator="[
            'newPwd',
            { rules: [{ required: true, message: '请输入6-20位数组合密码!' }, { validator: passText }] }
          ]" type="password" autocomplete="new-password" @blur="handleConfirmBlur" />
        </a-form-item>
        <a-form-item maxLength="20" :labelCol="labelCol" :wrapperCol="wrapperCol" label="重新输入新密码" has-feedback>
          <a-input :min="5" :max="20" v-decorator="[
            'confirm',
            { rules: [{ required: true, message: '请重新输入新密码!' }, { validator: compareToFirstPassword }] }
          ]" type="password" autocomplete="new-password" @blur="handleConfirmBlur" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 34%">
          <a-button type="primary" style="margin-right: 20px; width: 120px" html-type="submit">提交</a-button>
          <a-button style="width: 120px" @click="goBack2">取消</a-button>
          <!--<a-button type="primary" html-type="submit">-->
          <!--Register-->
          <!--</a-button>-->
        </a-form-item>
      </a-form>
    </a-modal>
    <!--会员-->
    <a-modal title="会员" style="top: 20px" :width="800" v-model="visible6" :confirmLoading="confirmLoading"
      @cancel="handleClose4" :maskClosable="false" @ok="handleSubmit4">
      <a-form :form="form4" @submit="handleSubmit4">
        <a-form-item label="会员地址位置类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['memberLocationType', { rules: [{ required: true, message: '请选择会员地址位置类型' }] }]">
            <a-select-option :key="0">大陆用户</a-select-option>
            <a-select-option :key="1">非大陆用户</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="个人名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['personName']"></a-input>
        </a-form-item>
        <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['personPhone']"></a-input>
        </a-form-item>
        <a-form-item label="身份证号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="['personIdCard']"></a-input>
        </a-form-item>
        <a-form-item label="个人职位" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['personPosition']">
            <a-select-option v-for="type in cdata" :key="type.cityCode">{{  type.cityName  }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="个人所属行业" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select v-decorator="['personIndustry']">
            <a-select-option v-for="type in cdata" :key="type.cityCode">{{  type.cityName  }}</a-select-option>
          </a-select>
        </a-form-item>
      </a-form>
    </a-modal>
    <tomap ref="model9"></tomap>
    <user-pwd-modal ref="pwdmodal" />
    <p-d-fmodel ref="modal2"></p-d-fmodel>
  </div>
</template>
<script>
import { STable } from '@/components'
import { Radar } from '@/components'
import {
  employeeInfoPush,
  MasterOperation,
  idCardOrc,
  selectFindAll,
  getSelectBrand,
  selectMasterChooseArea,
  noAduitUserArea,
  aduitUserArea,
  roleAll,
  resetMasterPwd,
  Pointget,
  noMainMasterContract,
  toMainMasterContract,
  editMasterContract,
  queryContractByMaster,
  editMasterPrice,
  deleteMasterContract,
  enableMasterContract,
  disableMasterContract,
  queryMasterPrice,
  addUserArea,
  deleteUserArea,
  getSelectAllProvince,
  getelectCityName,
  getelectAreaName,
  selectInstallTypeAndLabel,
  getList,
  findByDeptId,
  editMaster,
  queryMasterAccessoryPrice,
  queryUserArea,
  batchAuditArea,
  batchDeleteUserArea
} from '@/api/master/MasterList'
import { checkPermission } from '@/utils/permissions'
import { getDictMap } from '../../../utils/dict'
import pick from 'lodash.pick'
import tomap from './Map.vue'
import PDFmodel from './PDFmodel.vue'
import UserPwdModal from '@/views/system/modules/UserPwdModal'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import moment from 'moment'
import AFormItem from 'ant-design-vue/es/form/FormItem'
import _ from 'lodash'

const EditableCell = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-input :value="value" @change="handleChange" @pressEnter="check" style="width: 210px" />
          <a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          {{ value || ' ' }}
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    text: String
  },
  data() {
    return {
      value: this.text,
      editable: false
    }
  },
  methods: {
    handleChange(e) {
      // console.log('handleChange')
      const value = e.target.value
      this.value = value
    },
    check() {
      // console.log('check')
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      // console.log('edit')
      this.editable = true
    }
  }
}
//合同有效期
const EditableCell2 = {
  template: `
      <div class="editable-cell">
        <div v-if="editable" class="editable-cell-input-wrapper">
          <a-range-picker
            class="editable-cell-icon-check"
            style="width:210px"
            v-model="dataTime"
            @change="ChangeTime"
            :ranges="{ Today: [moment(), moment()], 'This Month': [moment(), moment().endOf('month')] }"
          />
          <a-input  @pressEnter="check" style="width: 210px;display: none" />
          <a-icon
            type="check"
            class="editable-cell-icon-check"
            @click="check"
            style="width:210px"
          />
        </div>
        <div v-else class="editable-cell-text-wrapper">
          <sapn v-if="start === null || end ===null"></sapn>
          <sapn v-else>{{ start + ' - ' + end || ' ' }}</sapn>
          <a-icon type="edit" class="editable-cell-icon" @click="edit" />
        </div>
      </div>
    `,
  props: {
    start: String,
    end: String
  },
  data() {
    return {
      value: this.text,
      editable: false,
      dataTime: ''
      // show:true,
    }
  },
  methods: {
    ChangeTime(dates, dateStrings) {
      // console.log(dateStrings)
      this.start = dateStrings[0]
      this.end = dateStrings[1]
      if (this.start != '' && this.end != '') {
        this.value = [dateStrings[0], dateStrings[1]]
        this.dataTime = [moment(dateStrings[0]), moment(dateStrings[1])]
      }
    },
    handleChange(e) {
      const value = e.target.value
      this.value = value
    },
    check() {
      this.editable = false
      this.$emit('change', this.value)
    },
    edit() {
      this.editable = true
    }
  }
}

export default {
  name: 'TableList',
  components: {
    AFormItem,
    STable,
    Radar,
    EditableCell,
    EditableCell2,
    tomap,
    UserPwdModal,
    PDFmodel
  },
  // props: {
  //   memberList: Array
  // },
  data() {
    return {
      // 分页
      pageSizeOptions: ['10', '20', '30', '40', '50'],
      total: 0,
      current: 1,
      pageSize: 10,
      queryParam: {},
      warnShow: false,
      userAreaIds2: '',
      userAreaIds: [],
      areaArray2: [],
      areaArray: [],
      checkAll: false,
      memberList: [],
      selectedRowKeys: [], // 选中的行key
      selectedTotalRows: [], // 选中的行数据
      bondTime: null,
      bondTimeTrue: '',
      activeKey: '1',
      idStartTime: '',
      idEndTime: '',
      dateFormat: 'YYYY-MM-DD HH:mm:ss',
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible2: false,
      visible3: false,
      visible4: false,
      visible5: false,
      visible6: false,
      isTrueText: false,
      isTrueTime: false,
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this), //服务区域
      form3: this.$form.createForm(this), //修改密码
      form4: this.$form.createForm(this), //会员
      form7: this.$form.createForm(this), //履历
      mdl: {},
      bond: '',
      nameAuth: '',
      oldPwd: '',
      oldPwdLis: '',
      confirmDirty: false, //密码验证
      addd: [], //服务类别回显
      // 高级搜索 展开/关闭
      advanced: false,
      confirmLoading: false,
      staType: false, //
      // 查询参数
      queryParam7: {},
      setData: [], //总接单情况
      // 表头
      columns: [
        { title: '序号', dataIndex: 'title', align: 'center' },
        {
          title: '配件类型',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'title',
          align: 'center'
        },
        {
          title: '配件型号',
          dataIndex: 'importance',
          align: 'center'
        },
        {
          title: '配件规格',
          dataIndex: 'receiveRole',
          align: 'center'
        },
        {
          title: '可使用品牌',
          dataIndex: 'startTime',
          align: 'center'
        },
        {
          title: '可使用型号',
          dataIndex: 'endTime',
          align: 'center'
        },
        {
          title: '配件金额',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '可使用区域',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '可使用数量',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '库存数量',
          dataIndex: 'status',
          align: 'center'
        },
        {
          title: '结算方式',
          dataIndex: 'status',
          align: 'center'
        }
      ],
      columns1: [
        {
          title: '总结单量',
          dataIndex: 'receiveOrder',
          scopedSlots: { customRender: 'receiveOrder' },
          align: 'center'
        },
        {
          title: '未销单',
          dataIndex: 'noWriteOrder',
          scopedSlots: { customRender: 'noWriteOrder' },
          align: 'center'
        },
        {
          title: '总投诉率',
          dataIndex: 'complaintRate',
          scopedSlots: { customRender: 'complaintRate' },
          align: 'center'
        }
      ],
      // 钱包
      columns2: [
        {
          title: '已结算',
          dataIndex: 'completePrice',
          scopedSlots: { customRender: 'completePrice' },
          align: 'center'
        },
        {
          title: '待结算',
          dataIndex: 'pendingPrice',
          scopedSlots: { customRender: 'pendingPrice' },
          align: 'center'
        },
        // {
        //   title: '可提现金额',
        //   dataIndex: 'cashPrice',
        //   scopedSlots: { customRender: 'cashPrice'},
        //   align: 'center',
        // },
        {
          title: '保证金',
          dataIndex: 'bond',
          scopedSlots: { customRender: 'bond' },
          align: 'center'
        }
      ],
      // 合同
      columns3: [
        {
          title: '合同文件',
          dataIndex: 'receiveOrder',
          scopedSlots: { customRender: 'receiveOrder' }
        },
        {
          title: '',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        },
        {
          title: '合同编号',
          dataIndex: 'contractNo',
          scopedSlots: { customRender: 'contractNo' }
        },
        {
          title: '合同名称',
          dataIndex: 'contractName',
          scopedSlots: { customRender: 'contractName' }
        },
        {
          title: '合同有效期',
          dataIndex: 'time1',
          scopedSlots: { customRender: 'time1' }
        },
        {
          title: '',
          dataIndex: 'action2',
          scopedSlots: { customRender: 'action2' }
        }
      ],
      columns4: [
        {
          title: '姓名',
          dataIndex: 'userName',
          align: 'center'
        },
        {
          title: '省',
          dataIndex: 'provinceName',
          align: 'center'
        },
        {
          title: '市',
          dataIndex: 'cityName',
          align: 'center'
        },
        {
          title: '区',
          dataIndex: 'areaName',
          align: 'center'
        },
        {
          title: '审核状态',
          dataIndex: 'aduitStatus',
          scopedSlots: { customRender: 'aduitStatus' },
          align: 'center'
        }
        // {
        //   title: '操作',
        //   dataIndex: 'action',
        //   scopedSlots: { customRender: 'action'},
        //   align: 'center'
        // },
      ],
      // 配件
      columns5: [
        {
          title: '序号',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '配件类型',
          dataIndex: 'accessoryType',
          align: 'center'
        },
        {
          title: '配件名称',
          dataIndex: 'accessoryName',
          align: 'center'
        },
        {
          title: '配件型号',
          dataIndex: 'accessoryCategory',
          align: 'center'
        },
        {
          title: '配件规格',
          dataIndex: 'accessorySpecification',
          align: 'center'
        },
        {
          title: '可使用品牌',
          dataIndex: 'brandName',
          align: 'center'
        },
        {
          title: '配件金额',
          dataIndex: 'accessoryPrice',
          align: 'center'
        },
        {
          title: '可使用区域',
          dataIndex: 'useArea',
          align: 'center'
        },
        {
          title: '已使用数量',
          dataIndex: 'usedNumber',
          align: 'center'
        },
        {
          title: '库存数量',
          dataIndex: 'stockNumber',
          align: 'center'
        },
        {
          title: '结算方式',
          dataIndex: 'paymentType',
          align: 'center'
        }
      ],
      // 接单情况
      columns6: [
        {
          title: '接单量',
          dataIndex: 'receiveOrderSingle',
          scopedSlots: { customRender: 'receiveOrderSingle' },
          align: 'center'
        },
        {
          title: '未销单',
          dataIndex: 'noWriteOrderSingle',
          align: 'center'
        },
        {
          title: '近30天投诉率',
          dataIndex: 'complaintRateRecent',
          align: 'center'
        }
      ],
      // 履历
      columns7: [
        {
          title: '序号',
          width: '65px',
          dataIndex: 'rowNum',
          align: 'center'
        },
        {
          title: '师傅类型',
          dataIndex: 'masterType',
          align: 'center'
        },
        {
          title: '操作模块',
          dataIndex: 'typeModel',
          align: 'center'
        },
        {
          title: '操作类型',
          dataIndex: 'operationType',
          align: 'center'
        },
        {
          title: '操作内容',
          dataIndex: 'operationInfo',
          scopedSlots: { customRender: 'action7' },
          align: 'center'
        },
        {
          title: '操作人',
          width: '130px',
          dataIndex: 'createBy',
          align: 'center'
        },
        {
          title: '操作时间',
          dataIndex: 'createTime',
          align: 'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData7: parameter => {
        return MasterOperation(Object.assign(parameter, this.queryParam7))
      },
      restaurantTypes: [],
      restaurantTypes1: [],
      restaurantTypes2: [],
      restaurantTypes3: [],
      restaurantTypes4: [],
      restaurantTypes5: [],
      restaurantTypes6: [],
      restaurantTypes7: [],
      // 省市区
      data1: [],
      data2: [],
      data3: [],
      data4: [],
      cdata: [],
      sdata: [],
      coverageData: [], //服务区域
      pullDown: [], //师傅负责人
      setData2: [], //师傅钱包
      orderReceive: [], //接单情况
      installTabs: [], //服务类别
      contractData: [], //合同
      money: [], //金额信息
      installType: [], //标签...雷达图
      accessories: '', //配件
      updateTime: '',
      open1: false,
      record: '', // 新建，编辑带过来的数据
      recordPass: '',
      passReset: '',
      abilityScore: '', // 得分
      roleAll: [],
      enterpriseShow: '',
      relationId: '',
      replece: {
        0: '待审核',
        1: '审核通过'
      },
      // 服务区域的区选择下拉框
      addList: {
        provinceId: '',
        userId: ''
      },
      coverageStatus: 0,
      // 雷达图
      ScoreArr: {
        firstFicScore: '',
        firstFicTransparency: '',
        secondFicScore: '',
        secondFicTransparency: ''
      },
      // 上传
      isType: '', // 合同上传判断
      isType2: '', // 照片上传判断
      previewVisible1: false,
      previewVisible2: false,
      previewVisible3: false,
      uploadUrlb: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=master',
      uploadUrl: '',
      headers: {
        token: Vue.ls.get(ACCESS_TOKEN)
      },
      fileList1: [],
      fileList2: [],
      fileList3: [],
      fileList4: [],
      coverUrl1: '',
      coverUrl2: '',
      coverUrl3: '',
      workType: '',
      identity: [
        {
          identityType: '',
          identityUrl: ''
        },
        {
          identityType: '',
          identityUrl: ''
        },
        {
          identityType: '',
          identityUrl: ''
        }
      ], //上传图片
      bankName: [
        { id: '中国工商银行', name: '中国工商银行' },
        { id: '中国银行', name: '中国银行' },
        { id: '中国建设银行', name: '中国建设银行' },
        { id: '中国农业银行', name: '中国农业银行' },
        { id: '交通银行', name: '交通银行' },
        { id: '中国邮政储蓄银行', name: '中国邮政储蓄银行' },
        { id: '招商银行', name: '招商银行' },
        { id: '上海浦东发展银行', name: '上海浦东发展银行' },
        { id: '民生银行', name: '民生银行' },
        { id: '兴业银行', name: '兴业银行' },
        { id: '中信银行', name: '中信银行' },
        { id: '平安银行', name: '平安银行' },
        { id: '光大银行', name: '光大银行' },
        { id: '华夏银行', name: '华夏银行' },
        { id: '广发银行', name: '广发银行' },
        { id: '上海银行', name: '上海银行' },
        { id: '南京银行', name: '南京银行' },
        { id: '渤海银行', name: '渤海银行' },
        { id: '江苏银行', name: '江苏银行' },
        { id: '恒丰银行', name: '恒丰银行' },
        { id: '徽商银行', name: '徽商银行' },
        { id: '国家开发银行', name: '国家开发银行' },
        { id: '上海农村商业银行', name: '上海农村商业银行' },
        { id: '农村信用社', name: '农村信用社' },
        { id: '农村合作银行', name: '农村合作银行' }
      ],
      resetPwdEnable: checkPermission('master:marsterlist:resetpwd'),
      areaEnable: checkPermission('master:list:area:query'),
      editAreaEnable: checkPermission('master:list:area:edit'),
      editInnerArchivesEnable: checkPermission('master:list:info:archives:editInner'),
      showPriceEnable: checkPermission('master:list:view:price:showPrice'),
      showRemarkEnable: checkPermission('master:list:view:price:showRemark'),
      editPriceEnable: checkPermission('master:list:view:price:edit'),
      detailsViewEnable: checkPermission('master:ContractManagement:view:details'),
      editsViewEnable: checkPermission('master:ContractManagement:view:edit'),
      deleteViewEnable: checkPermission('master:ContractManagement:view:delete'),
      baseCommon: checkPermission('master:list:info:base:common'),
      baseInner: checkPermission('master:list:info:base:inner'),
      editCommon: checkPermission('master:list:info:archives:editCommon'),
      archivesCommon: checkPermission('master:list:info:archives:common'),
      innerArchivesEnable: checkPermission('master:list:info:archives:inner'),
      viewPrice: checkPermission('master:list:view:price'),
      infoBase: checkPermission('master:list:info:base')
    }
  },
  filters: {},
  beforeCreate() {
    this.form = this.$form.createForm(this)
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
          this.userAreaIds = selectedRowKeys
          this.userAreaIds2 = selectedRows
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.aduitStatus == '', // Column configuration not to be checked
            aduitStatus: record.aduitStatus
          }
        })
      }

      // console.log("record", record)
    }
  },

  async created() {
    // console.log(this.areaEnable)
    selectFindAll({
      dictTypes: 'worker_type,install_type,tech_level,receipt_type,cash_cycle,cash_status,platform_type,sys_user_sex'
    }).then(res => {
      this.restaurantTypes = []
      this.restaurantTypes1 = []
      this.restaurantTypes2 = []
      this.restaurantTypes3 = []
      this.restaurantTypes4 = []
      this.restaurantTypes5 = []
      this.restaurantTypes6 = []
      this.restaurantTypes7 = []
      this.restaurantOperTypeMap = res.worker_type
      this.restaurantOperTypeMap1 = res.install_type
      this.restaurantOperTypeMap2 = res.tech_level
      this.restaurantOperTypeMap3 = res.receipt_type
      this.restaurantOperTypeMap4 = res.cash_cycle
      this.restaurantOperTypeMap5 = res.cash_status
      this.restaurantOperTypeMap6 = res.platform_type
      this.restaurantOperTypeMap7 = res.sys_user_sex
      this.restaurantOperTypeMap.forEach((value, key) => {
        this.restaurantTypes.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap2.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes2.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap3.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes3.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap4.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes4.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap5.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes5.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap6.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes6.push({ code: value.dictValue, label: value.dictLabel })
      })
      this.restaurantOperTypeMap7.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes7.push({ code: value.dictValue, label: value.dictLabel })
      })
    })
    getSelectAllProvince().then(res => {
      // console.log(res)
      this.data1 = res.rows
    })
    // 师傅负责人
    findByDeptId().then(res => {
      // console.log(res)
      this.pullDown = res
    })
    // employeeInfoPush().then(res=>{
    //   console.log(res)
    // })
  },
  methods: {
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    moment,
    // 分页
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.getdataList1(current)
    },

    getdataList1(value) {
      this.queryParam.pageNum = value
      this.queryParam.pageSize = this.pageSize
      queryUserArea(this.queryParam).then(res => {
        // console.log(res.rows)
        this.coverageData = res.rows
        this.total = res.total
      })
    },

    onChange4(a) {
      this.checkAll = !this.checkAll
      if (this.checkAll == true) {
        this.$nextTick(() => {
          this.form2.setFieldsValue({
            areaArray: this.areaArray2
          })
        })
      } else {
        this.form2.setFieldsValue({
          areaArray: []
        })
      }
    },

    onChange(checkedValues) {
      console.log('checked = ', checkedValues)
      if (checkedValues.length == this.areaArray2.length) {
        this.checkAll = true
      } else {
        this.checkAll = false
      }
      this.$nextTick(() => {
        this.form2.setFieldsValue({
          areaArray: checkedValues
        })
      })
    },

    edit(record, key, isEdit, type) {
      if (type) {
        this.staType = true
      }
      // console.log(record,key,isEdit)
      this.relationId = record.relationId
      this.enterpriseShow = isEdit
      this.bond = record.bond
      this.nameAuth = record.nameAuth
      // console.log(this.bond,this.nameAuth)
      this.activeKey = key
      let that = this
      this.form.resetFields()
      // 詳情
      this.record = record
      let userId = record.userId
      this.fileList1.splice(0, this.fileList1.length)
      this.fileList2.splice(0, this.fileList2.length)
      this.fileList3.splice(0, this.fileList3.length)
      // 详情
      getList({ userId }).then(res => {
        this.uploadUrl = process.env.VUE_APP_API_BASE_URL + '/dfs/uploadContract?type=MasterContract&id=' + userId
        console.log('详情', res.data)
        this.bondTimeTrue = res.data.bondTime
        this.recordPass = res.data
        this.passReset = res.data
        // console.log('重置详情',this.passReset)
        this.visible2 = true
        this.addd = []
        this.identity = [
          {
            identityType: '',
            identityUrl: ''
          },
          {
            identityType: '',
            identityUrl: ''
          },
          {
            identityType: '',
            identityUrl: ''
          }
        ]
        // 上传图片回显M
        for (let id of res.data.identity) {
          if (id.identityType == '0') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
              '/dfs/download?fileName=' +
              id.identityUrl +
              '&token=' +
              Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList1.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl
                })
              }
            )
            this.identity[0].identityType = 0
            this.identity[0].identityUrl = id.identityUrl
          }

          if (id.identityType == '1') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
              '/dfs/download?fileName=' +
              id.identityUrl +
              '&token=' +
              Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList2.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl
                })
              }
            )
            this.identity[1].identityType = 1
            this.identity[1].identityUrl = id.identityUrl
          }
          if (id.identityType == '2') {
            this.getImgToBase64(
              process.env.VUE_APP_API_BASE_URL +
              '/dfs/download?fileName=' +
              id.identityUrl +
              '&token=' +
              Vue.ls.get(ACCESS_TOKEN),
              function (data) {
                that.fileList3.push({
                  uid: id.identityType,
                  name: '',
                  status: 'done',
                  thumbUrl: data,
                  url: id.identityUrl
                })
              }
            )
            this.identity[2].identityType = 2
            this.identity[2].identityUrl = id.identityUrl
          }
        }
        // console.log(this.fileList1)
        // 时间控件回显
        this.updateTime = res.data.updateTime
        if (res.data.bondTime != null) {
          this.bondTime = moment(res.data.bondTime)
        } else {
          this.bondTime = null
        }
        this.idStartTime = res.data.idStartTime
        this.idEndTime = res.data.idEndTime
        // 师傅钱包
        this.setData2 = res.data.wallet
        // console.log(this.setData2)
        // 服务类别
        this.installType = res.data.installType
        this.workType = res.data.workerType
        // 总接单情况
        this.mdl = Object.assign(res.data)
        this.$nextTick(() => {
          this.setData = []
          let str = {}
          str.receiveOrder = res.data.receiveOrder
          str.noWriteOrder = res.data.noWriteOrder
          str.complaintRate = res.data.complaintRate
          this.setData.push(str)
          // 身份证有效期回显
          if (this.idStartTime != null && this.idEndTime != null) {
            this.mdl.time = [moment(this.idStartTime), moment(this.idEndTime)]
          }
          // console.log(this.mdl)
          // 服务类别回显
          for (var item of this.installType) {
            // console.log(item)
            this.addd.push(item.installType)
            // console.log(this.addd)
          }
          this.handleCheck11(this.addd)
          // 雷达图=>  页面初始时的那条数据
          let strArr = {}
          this.orderReceive = []
          // console.log(this.installType,this.addd[0])
          for (let m = 0; m < this.installType.length; m++) {
            if (this.installType[m].installType == this.addd[0]) {
              strArr = this.installType[m]
              this.orderReceive.push({
                noWriteOrderSingle: this.installType[m].noWriteOrderSingle,
                receiveOrderSingle: this.installType[m].receiveOrderSingle,
                complaintRateRecent: this.installType[m].complaintRateRecent,
                receiveOrderSingleMonth: this.installType[m].receiveOrderSingleMonth
              })
            }
          }
          // console.log(strArr)
          that.$nextTick(() => {
            that.initCharts(strArr)
          })
          // 角色下拉
          roleAll().then(res => {
            // console.log(res)
            this.roleAll = res.rows
          })
          // 省市区下拉
          getelectCityName({ provinceCode: this.mdl.provinceId }).then(res => {
            // console.log(res)
            this.data2 = res.rows
          })
          getelectAreaName({ cityCode: this.mdl.cityId }).then(res => {
            // console.log(res)
            this.data3 = res.rows
          })
          // 标签
          selectInstallTypeAndLabel().then(res => {
            this.data4 = res.data
          })
          //配件
          queryMasterAccessoryPrice({ userId }).then(res => {
            // console.log(res.data)
            this.accessories = res.data
          })
          // 金额信息
          queryMasterPrice({ userId }).then(res => {
            // console.log('金额信息',res.data)
            this.money = res.data
          })
          // 合同信息
          queryContractByMaster({ userId }).then(res => {
            // console.log('合同信息',res.rows)
            this.contractData = res.rows
          })
          this.form.setFieldsValue(
            pick(
              this.mdl,
              'roleIds',
              'time',
              'name',
              'phonenumber',
              'loginName',
              'password',
              'sex',
              'platformType',
              'receiptType',
              'isTop',
              'provinceId',
              'cityId',
              'districtId',
              'detailedAddress',
              'contactReserve',
              'installType',
              'masterLabel',
              'workerType',
              'techLevel',
              'cashStatus',
              'cashCycle',
              'privateMaster',
              'cardHouseHolder',
              'cardOrg',
              'cardNumber',
              'bond',
              'masterRemark',
              'idCard',
              'remark',
              'masterProvinceName',
              'masterLeading',
              'maxReceiveOrder'
            )
          )
          let value = this.form.getFieldValue('receiptType')
          if (value.includes('2')) {
            this.open1 = true
            this.form.setFieldsValue({ maxReceiveOrder: this.mdl.maxReceiveOrder })
          } else {
            this.open1 = false
          }
          this.handleSelect()
        })
      })
    },
    // 下载
    download(record) {
      // console.log(record)
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        record.contractAddresss +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      link.setAttribute('download', '导入学生账号模板')
      // let fileName = '问题反馈列表'
      // // 文件名中有中文 则对文件名进行转码
      // link.download = decodeURIComponent(fileName)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      // console.log(record,'record下载')
      // window.open(process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + record.contractAddresss + '&token=' + Vue.ls.get(ACCESS_TOKEN))
    },
    //身份证正则表达式
    idCards(rule, value, callback) {
      const pwdRegex = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的身份证格式'))
      } else {
        callback()
      }
    },
    //用户名正则表达式
    // userText (rule, value, callback) {
    //   const pwdRegex =/^[a-zA-Z0-9_-]{5,20}$/
    //   if(value==undefined||value.length == 0){
    //     callback(new Error('请输入用户名'))
    //   }else if (!pwdRegex.test(value)) {
    //     callback(new Error('请输入5到20位(字母,数字,下划线,减号)'))
    //   }else{
    //     callback()
    //   }
    // },
    //手机号正则表达式
    isPhone(rule, value, callback) {
      const pwdRegex = /^((0\d{2,3}(-)?\d{7,8})|(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8})$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入联系方式'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的联系方式'))
      } else {
        callback()
      }
    },
    //银行卡号正则表达式
    bankNum(rule, value, callback) {
      const pwdRegex = /^([1-9]{1})(\d{15}|\d{16}|\d{17}|\d{18})$/
      if (value == undefined || value.length == 0) {
        callback()
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入正确的银行卡号'))
      }
      callback()
    },
    // 审核通过
    getApproved(record) {
      // console.log(record)
      aduitUserArea({ userId: record.userId, auditId: record.auditId, userAreaId: record.userAreaId })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('审核通过')
            this.queryParam.userId = record.userId
            this.getdataList1(this.current)
            // queryUserArea({userId:record.userId}).then(res=>{
            //   // console.log(res.rows)
            //   this.coverageData = res.rows
            // })
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 审核不通过
    notApproved(record) {
      noAduitUserArea({ userId: record.userId, auditId: record.auditId, userAreaId: record.userAreaId })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('审核不通过')
            this.queryParam.userId = record.userId
            this.getdataList1(this.current)
            // queryUserArea({userId:record.userId}).then(res=>{
            //   // console.log(res.rows)
            //   this.coverageData = res.rows
            // })
          } else {
            this.$message.success(res.msg)
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 时间控件
    onChange1(date, dateString) {
      console.log('Formatted Selected Time: ', date, dateString)
      this.bondTime = date
      this.bondTimeTrue = dateString
    },
    onChange2(date, dateString) {
      // console.log('Selected Time: ', date);
      // console.log('Formatted Selected Time: ', dateString);
      this.idStartTime = dateString[0]
      this.idEndTime = dateString[1]
    },
    onChange3(date, dateString) {
      this.queryParam7.startTime = dateString[0]
      this.queryParam7.endTime = dateString[1]
    },
    onOk(value) {
      // console.log('onOk: ', value);
    },
    // tab页选择
    callback1(key) {
      this.activeKey = key
      if (key == 4) {
        this.$refs.table7.refresh(true)
      }
      // console.log(key);
    },
    // 切换服务类别=> 雷达图数据
    callback2(key) {
      // console.log(key);
      this.$nextTick(() => {
        this.$refs['tabPane'].activeKey = key
      })
      // console.log(this.installType)
      //数据中已有的服务类别
      for (let k = 0; k < this.installType.length; k++) {
        if (this.installType[k].installType == key) {
          this.initCharts(this.installType[k])
          // console.log(this.installType[k])
          this.orderReceive = []
          this.orderReceive.push({
            noWriteOrderSingle: this.installType[k].noWriteOrderSingle,
            receiveOrderSingle: this.installType[k].receiveOrderSingle,
            complaintRateRecent: this.installType[k].complaintRateRecent,
            receiveOrderSingleMonth: this.installType[k].receiveOrderSingleMonth
          })
        }
      }
    },
    callback3(key) {
      // console.log(key);
    },
    // 履历检索
    handleSelect() {
      delete this.queryParam7.time
      this.queryParam7.masterId = this.record.userId
      this.$refs.table7.refresh(true)
    },
    handleClear() {
      this.queryParam7 = {}
    },
    // 接单方式
    haveSelect(values) {
      // console.log(values)
      if (values.includes('2')) {
        this.open1 = true
      } else {
        this.open1 = false
      }
    },
    // 服务类别
    handleCheck11(values) {
      //alert(JSON.stringify(values))
      // alert(JSON.stringify(this.restaurantTypes1))
      // console.log(values)
      this.installTabs = []
      let that = this
      let arr = this.restaurantTypes1
      for (var j = 0; j < values.length; j++) {
        // console.log(values[j])
        for (var i = 0; i < arr.length; i++) {
          // console.log(arr[i],values[j])
          if (values[j] == arr[i].code) {
            let isList = {}
            isList.code = arr[i].code
            isList.label = arr[i].label
            this.installTabs.push(isList)
          }
        }
      }

      this.$nextTick(() => {
        if (this.installTabs.length > 0) {
          this.$refs['tabPane'].activeKey = this.installTabs[this.installTabs.length - 1].code
        }
      })
    },
    handleCheck2(values) {
      // console.log(values)
    },
    handleMembers() {
      this.visible6 = true
      console.log(this.recordPass)
    },
    // 主页=>服务区域
    handleCoverage(values) {
      // console.log("values",values)
      this.coverageStatus = 0
      this.addList.userId = values.userId
      this.record = values
      this.visible3 = true
      this.queryParam.userId = values.userId
      this.getdataList1(1)
      // queryUserArea({userId:values.userId}).then(res=>{
      //   // console.log(res.rows)
      //   this.coverageData = res.rows
      //   this.total = res.total
      // })
      this.selectedRowKeys = [] // 选中的行key
    },
    // 编辑=>服务区域
    coverage() {
      this.coverageStatus = 1
      this.addList.userId = this.record.userId
      this.visible2 = false
      this.visible3 = true
      this.queryParam.userId = this.record.userId
      this.getdataList1(1)
      // queryUserArea({userId:this.record.userId}).then(res=>{
      //   // console.log(res.rows)
      //   this.coverageData = res.rows
      // })
    },
    // 服务区域的新增
    addItem1() {
      this.form2.setFieldsValue({
        areaArray: []
      })
      this.warnShow = false
      this.form2.resetFields()
      this.sdata = []
      this.visible4 = true
      this.checkAll = false
    },
    // 服务区域的审核通过
    addItem2(selectedRowKeys) {
      // const area={
      //   userId:selectedRowKeys.userId,
      //   aduitStatus:1,
      //   userAreaIds:this.userAreaIds,
      //   auditId:this.userAreaIds2[0].auditId
      // }
      batchAuditArea({
        userId: selectedRowKeys.userId,
        aduitStatus: 1,
        userAreaIds: this.userAreaIds,
        auditId: this.userAreaIds2[0].auditId
      }).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.$message.success('审核通过')
          this.queryParam.userId = selectedRowKeys.userId
          this.getdataList1(this.current)
          // queryUserArea({userId:selectedRowKeys.userId}).then(res=>{
          //   // console.log(res.rows)
          //   this.coverageData = res.rows
          // })
        } else {
          this.$message.success(res.msg)
        }
      })
      // this.userAreaIds2 =
      // console.log("selectedRowKeys",selectedRowKeys)

      this.form2.resetFields()
    },

    // 服务区域的审核不通过
    addItem3(selectedRowKeys) {
      batchAuditArea({
        userId: selectedRowKeys.userId,
        aduitStatus: 0,
        userAreaIds: this.userAreaIds,
        auditId: this.userAreaIds2[0].auditId
      }).then(res => {
        // console.log(res)
        if (res.code === 0) {
          this.$message.success('审核未通过')
          this.queryParam.userId = selectedRowKeys.userId
          this.getdataList1(this.current)
          // queryUserArea({userId:selectedRowKeys.userId}).then(res=>{
          //   // console.log(res.rows)
          //   this.coverageData = res.rows
          // })
        } else {
          this.$message.success(res.msg)
        }
      })
      // this.userAreaIds2 =
      // console.log("selectedRowKeys",selectedRowKeys)

      this.form2.resetFields()
      this.form2.resetFields()
    },

    // 服务区删除
    delectCoverage(userAreaId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定将本条数据删除吗？',
        okType: 'danger',
        onOk() {
          batchDeleteUserArea(that.userAreaIds)
            .then(res => {
              if (res.code == 0) {
                that.$message.success('删除成功')
              } else {
                that.$message.success(res.msg)
              }
            })
            .then(res => {
              that.queryParam.userId = that.record.userId
              that.getdataList1(that.current)
              // queryUserArea({userId:that.record.userId}).then(res=>{
              //   that.coverageData = res.rows
              // })
            })
        },
        onCancel() {
          // console.log('Cancel');
        }
      })
    },
    // 修改密码
    handlePass() {
      this.form3.resetFields()
      this.visible5 = true
    },
    handleConfirmBlur(e) {
      const value = e.target.value
      this.confirmDirty = this.confirmDirty || !!value
    },
    compareToFirstPassword(rule, value, callback) {
      const form = this.form3
      if (value && value !== form.getFieldValue('newPwd')) {
        callback('两次密码不一致!')
      } else {
        callback()
      }
    },
    //密码正则表达式
    passText(rule, value, callback) {
      // const pwdRegex =/^[a-zA-Z0-9_-]{6,20}$/
      const pwdRegex = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z/*\-+.~!@#$%^&*(),?`<>;':"]{6,12}$/
      if (value == undefined || value.length == 0) {
        callback(new Error('请输入密码'))
      } else if (!pwdRegex.test(value)) {
        callback(new Error('请输入6到12位(至少包含字母，数字，特殊符号任意两种)'))
      } else {
        callback()
      }
    },
    // checkPhone(rule, value, callback) {
    //   const form = this.form
    //   // const pwdRegex = new RegExp('^[0-9a-zA-Z]{5,20}$')
    //   const pwdRegex = new RegExp('^[a-zA-Z0-9_-]{6,20}$')
    //   if (!pwdRegex.test(value) && value.length != 0) {
    //     callback(new Error('请输入6-20位的数字或者字母'))
    //   } else if (value && this.confirmDirty) {
    //     form.validateFields(['confirm'], { force: true })
    //   }
    //   callback()
    // },
    goBack2() {
      this.visible5 = false
    },
    // 重置密码
    resetPwd(value) {
      // console.log('重置密码按钮',value)
      this.$refs.pwdmodal.edit(value)
    },
    // 省市区下拉
    haveProvince3(e) {
      this.data2 = []
      this.data3 = []
      this.form.setFieldsValue({ cityId: undefined, districtId: undefined, detailedAddress: '' })
      getelectCityName({ provinceCode: e }).then(res => {
        // console.log(res)
        this.data2 = res.rows
      })
    },
    haveProvince4(e) {
      this.data3 = []
      this.form.setFieldsValue({ districtId: undefined, detailedAddress: '' })
      getelectAreaName({ cityCode: e }).then(res => {
        // console.log(res)
        this.data3 = res.rows
      })
    },
    haveProvince5() {
      this.form.setFieldsValue({ detailedAddress: '' })
    },
    haveProvince02(value) {
      // console.log(value)
      this.sdata = []
      this.checkAll = false
      this.warnShow = false
      this.form2.setFieldsValue({ cityId: undefined, areaId: [], areaArray: [] })
      this.addList.provinceId = value
      getelectCityName({ provinceCode: value }).then(res => {
        // console.log(res)
        this.cdata = res.rows
      })
    },
    haveProvince03(value) {
      this.checkAll = false
      this.warnShow = false
      this.areaArray2 = []
      this.sdata = []
      this.form2.setFieldsValue({ areaId: [], areaArray: [] })
      selectMasterChooseArea({ userId: this.addList.userId, provinceId: this.addList.provinceId, cityId: value }).then(
        res => {
          // console.log(res)
          this.sdata = res.data
          for (let i = 0; i < this.sdata.length; i++) {
            this.areaArray2.push(this.sdata[i].areaId)
          }
        }
      )
    },

    // 多选
    handChange(value) {
      // console.log(`selected ${value}`);
    },
    //将图片转换为Base64
    getImgToBase64(url, callback) {
      var canvas = document.createElement('canvas'),
        ctx = canvas.getContext('2d'),
        img = new Image()
      img.crossOrigin = 'Anonymous'
      img.onload = function () {
        canvas.height = img.height
        canvas.width = img.width
        ctx.drawImage(img, 0, 0)
        var dataURL = canvas.toDataURL('image/png')
        callback(dataURL)
        canvas = null
      }
      img.src = url
    },
    beforeUpload1(file) {
      // console.log(file)
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        this.isType2 = 1
        return false
      } else {
        this.isType2 = 0
      }
    },
    // 上传1
    handChange1({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList1 = fileList
        if (fileList.length == 0) {
          this.identity[0].identityType = ''
          this.identity[0].identityUrl = ''
          this.isTrueText = false
        } else {
          this.coverUrl1 = fileList[0].response.url
          this.identity[0].identityType = 0
          this.identity[0].identityUrl = this.coverUrl1
        }
        if (fileList[0].status == 'done') {
          let url =
            process.env.VUE_APP_API_BASE_URL +
            '/dfs/download?fileName=' +
            fileList[0].response.url +
            '&token=' +
            Vue.ls.get(ACCESS_TOKEN)
          // let url = 'http://121.36.221.107/api/dfs/download?fileName=master/2020/07/04/924f404897edb42e321fd120409f571e.png&token=3bab25a8ad0047cea16001e843c0fd6c'
          idCardOrc({ identityUrl: url, identityType: 0 }).then(res => {
            // console.log(res)
            if (res.code == 0) {
              if (res.data.riskType != 'unknown') {
                this.form.setFieldsValue({
                  name: res.data.name,
                  sex: res.data.sex == '女' ? '1' : '0',
                  idCard: res.data.cardNum
                })
                this.isTrueText = true
              }
            }
          })
        }
      }
    },
    handPreview1(file) {
      if (file.response) {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl1 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible1 = true
    },
    handCancel1() {
      this.previewVisible1 = false
    },
    // 上传2
    handChange2({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList2 = fileList
        if (fileList.length == 0) {
          this.identity[1].identityType = ''
          this.identity[1].identityUrl = ''
          this.isTrueTime = false
          // console.log(this.identity[1])
        } else {
          this.coverUrl2 = fileList[0].response.url
          this.identity[1].identityType = 1
          this.identity[1].identityUrl = this.coverUrl2
        }
        let url =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          fileList[0].response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
        // let url = 'http://121.36.221.107/api/dfs/download?fileName=master/2020/07/31/e61e6ecb2a12d4fc0ed4ada23548e1c3.jpg&token=3799467ae9714eb293146dd2fa4fcd11'
        if (fileList.length > 0 && fileList[0].status == 'done') {
          idCardOrc({ identityUrl: url, identityType: 1 }).then(res => {
            // console.log(res)
            let arr = []
            arr[0] = res.data.issuingDate.slice(0, 4)
            arr[1] = res.data.issuingDate.slice(4, 6)
            arr[2] = res.data.issuingDate.slice(-2)
            let str1 = arr.join('-')
            let arr1 = []
            arr1[0] = res.data.expiryDate.slice(0, 4)
            arr1[1] = res.data.expiryDate.slice(4, 6)
            arr1[2] = res.data.expiryDate.slice(-2)
            let str2 = arr1.join('-')
            if (res.data.riskType != 'unknown') {
              this.idStartTime = str1
              this.idEndTime = str2
              this.form.setFieldsValue({
                time: [moment(this.idStartTime), moment(this.idEndTime)]
              })
              this.isTrueTime = true
            }
          })
        }
      }
    },
    handPreview2(file) {
      if (file.response) {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl2 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible2 = true
    },
    handCancel2() {
      this.previewVisible2 = false
    },
    // 上传3
    handChange3({ fileList }) {
      if (this.isType2 == 0) {
        this.fileList3 = fileList
        if (fileList.length == 0) {
          this.identity[2].identityType = ''
          this.identity[2].identityUrl = ''
        } else {
          this.coverUrl3 = fileList[0].response.url
          this.identity[2].identityType = 2
          this.identity[2].identityUrl = this.coverUrl3
        }
      }
    },
    handPreview3(file) {
      if (file.response) {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL +
          '/dfs/download?fileName=' +
          file.response.url +
          '&token=' +
          Vue.ls.get(ACCESS_TOKEN)
      } else {
        this.coverUrl3 =
          process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
      }
      this.previewVisible3 = true
    },
    handCancel3() {
      this.previewVisible3 = false
    },
    beforeUpload(file) {
      let houzhui = file.name.split('.')
      houzhui = houzhui[houzhui.length - 1]
      const isJpgOrPng =
        houzhui == 'doc' ||
        houzhui == 'docx' ||
        houzhui == 'xls' ||
        houzhui == 'ppt' ||
        houzhui == 'pptx' ||
        houzhui == 'xlsx' ||
        houzhui == 'pdf'
      console.log(houzhui, isJpgOrPng)
      if (!isJpgOrPng) {
        this.$message.error('上传文件格式不支持!')
        return false
      }
    },
    // 上传合同
    uploadChange(info) {
      if (this.isType != 1) {
        this.fileList4 = info.fileList
      }
      if (info.file.status !== 'uploading') {
      }
      if (info.file.status === 'done') {
        this.$message.success(`上传成功`)
        queryContractByMaster({ userId: this.record.userId }).then(res => {
          // console.log('合同信息',res.rows)
          this.fileList4 = []
          this.contractData = res.rows
        })
      } else if (info.file.status === 'error') {
        this.$message.error(`上传失败`)
        this.fileList4 = []
      }
    },
    // 查看合同
    handleSee(record) {
      // console.log(record)
      let contractPdfAddresss =
        process.env.VUE_APP_API_BASE_URL +
        '/dfs/download?fileName=' +
        record.contractPdfAddresss +
        '&token=' +
        Vue.ls.get(ACCESS_TOKEN)
      this.$refs.modal2.delsee(contractPdfAddresss)
    },
    // 标签回显
    getInitalValue(installType) {
      for (var item of this.installType) {
        if (item.installType == installType) {
          return item.masterLabel
        }
      }
    },

    // 关闭Modal
    handleClose() {
      this.visible2 = false
      this.$emit('ok')
    },
    handleClose1() {
      this.selectedRowKeys = []
      this.visible3 = false
      if (this.coverageStatus == 1) {
        this.visible2 = true
        this.selectedRowKeys = []
      }
    },
    handleClose2() {
      this.visible4 = false
    },
    getClose() {
      this.visible2 = false
      this.fileList1 = []
      this.fileList2 = []
      this.fileList3 = []
      this.tiem1 = ''
      this.$emit('ok')
    },

    showState(masterContractId, forbiddenStatus) {
      if (forbiddenStatus == 0) {
        disableMasterContract({ masterContractId: masterContractId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('禁用成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (forbiddenStatus == 1) {
        enableMasterContract({ masterContractId: masterContractId }).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.$message.success('启动成功')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    delByIds(masterContractId) {
      let that = this
      this.$confirm({
        title: '删除',
        content: '您确定删除本数据吗？',
        okType: 'danger',
        onOk() {
          deleteMasterContract({ masterContractId: masterContractId }).then(res => {
            if (res.code === 0) {
              that.$message.success('删除成功')
              queryContractByMaster({ userId: that.record.userId }).then(res => {
                that.contractData = res.rows
              })
            } else {
              that.$message.error(res.msg)
            }
          })
        },
        onCancel() {
          // console.log('Cancel');
        }
      })
    },
    // 刷新详情页合同列表
    handleOk() {
      queryContractByMaster({ userId: this.record.userId }).then(res => {
        // console.log('合同信息',res.rows)
        this.contractData = res.rows
      })
    },
    //修改编辑页合同列表
    onCellChange(record, dataIndex, value) {
      // console.log(record,dataIndex,value)
      if (dataIndex == 'contractNo') {
        editMasterContract({ masterContractId: record.masterContractId, contractNo: value }).then(res => {
          if (res.code === 0) {
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      } else if (dataIndex == 'contractName') {
        editMasterContract({ masterContractId: record.masterContractId, contractName: value }).then(res => {
          if (res.code === 0) {
            this.$message.success('修改成功')
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    onCellChange2(record, dataIndex, value) {
      // console.log(record,dataIndex,value)
      editMasterContract({
        masterContractId: record.masterContractId,
        contractStartTime: value[0],
        contractEndTime: value[1]
      }).then(res => {
        if (res.code === 0) {
          this.$message.success('修改成功')
          this.handleOk()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 设主合同
    checkChange(value) {
      // console.log(value)
      if (value.isMainContract == '0') {
        toMainMasterContract({
          masterContractId: value.masterContractId,
          userId: this.record.userId
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('已设为主合同')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        noMainMasterContract({
          masterContractId: value.masterContractId,
          userId: this.record.userId
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('已取消主合同')
            this.handleOk()
          } else {
            this.$message.error(res.msg)
          }
        })
      }
    },
    //电子围栏按钮
    Tomap() {
      let that = this
      Pointget(this.record.userId).then(res => {
        // console.log(res)
        this.$refs.model9.add(res.data, this.record.userId)
        // that.$refs.tomaps.add(res.data,0)
      })
    },
    // 雷达图
    initCharts(data) {
      let that = this
      // console.log(data,'传参后的雷达数据')
      let myChart = this.$echarts.init(this.$refs.chart)
      let dateArr = []
      let NameArr = []
      let nameStr = []
      for (var k = 0; k < data.masterAbility.length; k++) {
        if (data.masterAbility[k].abilityName == '总评分') {
          this.abilityScore = data.masterAbility[k].abilityScore
        } else {
          dateArr.push(data.masterAbility[k].abilityScore)
          NameArr.push({
            value: data.masterAbility[k].abilityScore, //能力得分
            abilityName: data.masterAbility[k].abilityName, //能力名称
            firstFicScore: data.masterAbility[k].firstFicScore, //虚拟得分1
            firstFicTransparency: data.masterAbility[k].firstFicTransparency, //虚拟得分透明度1
            secondFicTransparency: data.masterAbility[k].secondFicTransparency, //虚拟得分透明度2
            secondFicScore: data.masterAbility[k].secondFicScore //虚拟得分2
          })
          nameStr.push({
            name: data.masterAbility[k].abilityName,
            max: 10
          })
        }
      }
      // console.log(dateArr,NameArr,nameStr)
      // 绘制图表
      // console.log(dateArr,'雷达数组')
      // console.log(data.installType)
      myChart.setOption({
        title: {
          text: '服务能力'
        },
        radar: {
          indicator: nameStr,
          triggerEvent: true,
          radius: 90
        },
        series: [
          {
            name: '服务能力',
            type: 'radar',
            data: [
              {
                value: dateArr,
                name: data.installType
              }
            ]
          }
        ]
      })
      var alert = document.getElementById('alert')
      //鼠标事件
      myChart.on('mouseover', function (params) {
        // console.log(params)
        // console.log(NameArr,'循环数据')
        for (let i = 0; i < NameArr.length; i++) {
          if (NameArr[i].abilityName == params.name) {
            that.ScoreArr.firstFicScore = NameArr[i].firstFicScore
            that.ScoreArr.firstFicTransparency = NameArr[i].firstFicTransparency
            that.ScoreArr.secondFicScore = NameArr[i].secondFicScore
            that.ScoreArr.secondFicTransparency = NameArr[i].secondFicTransparency
            that.ScoreArr.installType = data.installType
          }
        }

        // if(params.name=="研发"){ //判断点击文字
        // console.log(that.ScoreArr)
        alert.style.left = params.event.offsetX + 20 + 'px'
        alert.style.top = params.event.offsetY + 10 + 'px'
        // console.log(params.event.offsetX,params.event.offsetY)
        if (params.event.offsetX > 200) {
          alert.style.left = '200px'
        }
        if (params.event.offsetY > 200) {
          alert.style.top = '100px'
        }
        if (params.event.offsetY > 100 && params.event.offsetX > 200) {
          alert.style.left = '60px'
          alert.style.top = '100px'
        }
        if (params.event.offsetY > 200 && params.event.offsetX > 200) {
          alert.style.left = '40px'
          alert.style.top = '100px'
        }
        alert.style.display = 'block'
        // }
      })
      myChart.on('mouseout', function (params) {
        // console.log(params)
        // if(params.name=="研发"){ //判断点击文字
        alert.style.display = 'none'
        // }
      })
    },

    // 提交
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, formValues) => {
        let values = _.cloneDeep(formValues)
        if (!err) {
          if (this.baseCommon) {
            let tempInstalTypes = []
            for (let installTypeIndex in formValues['installType']['installType']) {
              let installType = formValues['installType']['installType'][installTypeIndex]
              // console.log(installType)
              let str = {}
              str.code = installType
              str.masterLabel = []
              tempInstalTypes.push(str)
              // console.log('[]',tempInstalTypes)

              for (let val in formValues) {
                const index = val.indexOf('$' + installType)
                if (index !== -1) {
                  let obj = {}
                  obj['code'] = installType
                  obj['masterLabel'] = formValues[val]
                  for (var i in tempInstalTypes) {
                    if (tempInstalTypes[i].code == obj['code']) {
                      tempInstalTypes[i].masterLabel = formValues[val]
                    }
                  }

                  delete values[val]
                }
              }
            }
            values['installType']['installType'] = tempInstalTypes
          }

          if (this.workType != values['workerType'] && this.workType == 6) {
            this.$message.error('团长无法转换成其他角色!')
            return 0
          }
          if (values['workerType'] == 6 && this.workType != 6) {
            this.$message.error('其他角色无法转换成团长！')
            return 0
          }
          if (this.archivesCommon) {
            values.bondTime = this.bondTimeTrue
            values.identity = this.identity
            values.idStartTime = this.idStartTime
            values.idEndTime = this.idEndTime
          }
          values.updateTime = this.updateTime
          values.userId = this.record.userId
          delete values.time
          // console.log('最后：',values)
          editMaster(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                if (this.staType) {
                  this.$emit('ok', 2)
                }
                // this.$emit('ok')
                this.fileList1 = []
                this.fileList2 = []
                this.fileList3 = []
                this.visible2 = false
              } else {
                this.$message.error(res.msg)
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    },
    //添加服务区域
    handleSubmit02() {
      this.form2.validateFields((err, values) => {
        if (!err) {
          values.userId = this.record.userId
          values.areaId = values.areaArray
          console.log('Received values of form: ', values)
          if (values.areaId != undefined) {
            this.warnShow = false
            addUserArea(values)
              .then(res => {
                if (res.code === 0) {
                  this.$message.success('保存成功')
                  this.queryParam.userId = values.userId
                  this.getdataList1(1)

                  this.areaArray2 = []
                  this.sdata = []
                  this.visible4 = false
                } else {
                  this.$message.success(res.msg)
                }
              })
              .catch(() => {
                this.$message.error('系统错误，请稍后再试')
              })
              .finally(() => {
                this.confirmLoading = false
              })
          } else {
            this.warnShow = true
          }
        }
      })
    },
    // 修改金额提交
    handleSubmit1() {
      let result = []
      for (var item of this.money) {
        // console.log(item.masterPriceDto)
        result = result.concat(item.masterPriceDto)
      }
      editMasterPrice({ masterPriceDto: result })
        .then(res => {
          if (res.code == 0) {
            this.$message.success('修改成功')
          }
        })
        .catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
        .finally(() => {
          this.confirmLoading = false
        })
    },
    // 修改密码
    handleSubmit2(e) {
      e.preventDefault()
      this.form3.validateFields((err, values) => {
        delete values.confirm
        values.userId = this.recordPass.userId
        values.loginName = this.recordPass.loginName
        if (!err) {
          // console.log('Received values of form: ', values);
          resetMasterPwd(values)
            .then(res => {
              if (res.code === 0) {
                this.$message.success('保存成功')
                this.visible5 = false
              } else if (res.code == 1) {
                this.$message.error('原始密码错误！')
              }
            })
            .catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>
#alert {
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
}

/deep/ .redItem .ant-form-item-label label {
  color: red;
}

.redItem .ant-checkbox-wrapper {
  color: red;
}

/deep/ div .ant-tabs-nav-scroll {
  margin-left: 5%;
}

.changeColor {
  background-color: #1890ff;
  color: #fff;
}

.disEvents {
  pointer-events: none;
}

.disEvents2 {}

/deep/ .ant-table th {
  white-space: nowrap;
}

/deep/ .ant-table td {
  padding: 4px 16px;
}
</style>
